import styles from "../assets/styles/componenets/navbar.module.css";
import logo from "../assets/images/scale.svg";
import { useState, useEffect } from "react";

export default function NavBar() {
    const [fixed, setFixed] = useState(false);
    const [activeSection, setActiveSection] = useState("");

    useEffect(() => {
        const handleScroll = () => {
            const scrollPosition = window.scrollY + window.innerHeight / 3;
            const lessons = document.getElementById("lessons");
            const teachers = document.getElementById("teachers");
            const contactUs = document.getElementById("contact-us");

            // handle active link
            if (lessons && teachers && contactUs) {
                if (
                    scrollPosition >= lessons.offsetTop &&
                    scrollPosition < teachers.offsetTop
                ) {
                    setActiveSection("lessons");
                } else if (
                    scrollPosition >= teachers.offsetTop &&
                    scrollPosition < contactUs.offsetTop
                ) {
                    setActiveSection("teachers");
                } else if (scrollPosition >= contactUs.offsetTop) {
                    setActiveSection("contact-us");
                } else {
                    setActiveSection("");
                }
            }

            setFixed(window.scrollY >= 80);
        };

        window.addEventListener("scroll", handleScroll);
    }, []);

    return (
        <nav
            id="navbar"
            className={`${styles.container} ${fixed && styles.fixed}`}
        >
            <div className={styles.subcontainer}>
                <a href="#home" className={styles.logo}>
                    <img alt="logo" src={logo} />
                    <p>JUSTLAW</p>
                </a>
            </div>
            <div className={styles.subcontainer}>
                <a
                    href="#lessons"
                    className={`${styles.navLink} ${
                        activeSection === "lessons" ? styles.active : ""
                    }`}
                >
                    Դասընթացներ 
                    <span></span>
                </a>
                <a
                    href="#teachers"
                    className={`${styles.navLink} ${
                        activeSection === "teachers" ? styles.active : ""
                    }`}
                >
                    Դասախոսներ
                    <span></span>
                </a>
                <a
                    href="#contact-us"
                    className={`${styles.navLink} ${
                        activeSection === "contact-us" ? styles.active : ""
                    }`}
                >
                    Հետադարձ կապ
                    <span></span>
                </a>
            </div>
            <div className={styles.subcontainer}></div>
        </nav>
    );
}
